// extracted by mini-css-extract-plugin
module.exports = {"devEnvSwitcher":"styles_devEnvSwitcher__2Tc91","hover":"styles_hover__2524Y","hidden":"styles_hidden__1_BND","devEnvSwitcherWarning":"styles_devEnvSwitcherWarning__Reanz"};